(() => {
  const revealSelector = [
    '.vl-home-v2 > section:not(.vl-home-v2__hero)',
    '.vl-collection__catalog',
    '.vl-collection__compare',
    '.vl-collection__seo',
    '.vl-cap-bundle',
    '.vl-product-framework',
    '.vl-product-trust',
  ].join(',');

  const initReveal = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.documentElement.classList.add('vl-port-ready');
    const nodes = [...document.querySelectorAll(revealSelector)];
    if (!nodes.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('vl-port-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    nodes.forEach((node) => {
      node.classList.add('vl-port-reveal');
      observer.observe(node);
    });
  };

  const initCartArrival = () => {
    document.addEventListener('animationend', (event) => {
      if (!(event.target instanceof HTMLElement) || event.target.tagName !== 'FLY-TO-CART') return;
      const cart = document.querySelector('.header-actions__cart-icon');
      if (!cart) return;
      cart.classList.remove('vl-cart-arrival');
      window.requestAnimationFrame(() => cart.classList.add('vl-cart-arrival'));
      window.setTimeout(() => cart.classList.remove('vl-cart-arrival'), 520);
    });
  };

  const init = () => {
    initReveal();
    initCartArrival();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
